module.exports = __webpack_public_path__ + "img/layout_02_default.1d731606.svg";